import * as React from "react";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { PartLoading } from "../../../../../../react-core/Html/PartLoading";
import { PercentageTextBoxEditor } from "../../../../../../react-core/Html/PercentageTextBoxEditor";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { InvestorType } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { HeadAccountCgtSettings } from "../../../../../../Wrap/Models/Domains/Tax/HeadAccountCgtSettings";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { ClientAccountStore } from "../../../../Stroes/Variable";

interface ICGTProps extends IProcessComponentProps {
    data: HeadAccountCgtSettings;
}

interface ICGTState {
    isLoading: boolean;
}

export class CapitalGainsSettings extends ProcessComponent<ICGTProps, ICGTState> {
    constructor(props: ICGTProps) {
        super(props);
        this.state = {
            isLoading: CommonHelper.isNullOrEmpty(ClientAccountStore.getClientAccountInfo()),
        };
        this.subscribeToStore(ClientAccountStore, () => this.onStoreChange());
    }

    private onStoreChange() {
        const data = ClientAccountStore.getClientAccountInfo();
        if (data) {
            this.setState({ isLoading: false });
        }
    }

    render() {
        const { data, onChange } = this.props;
        const accountInfo = ClientAccountStore.getClientAccountInfo();
        return (
            <PartLoading isLoading={this.state.isLoading}>
                <h2>Capital Gain Settings</h2>

                <Typography
                    type="vertical"
                    config={[
                        {
                            title: "CGT allowance",
                            data: MoneyDisplayHelper.FromatMoneyDisplay(data?.AnnualCgtAllowance, CurrencyCode.GBP),
                        },
                    ]}
                />
                <PercentageTextBoxEditor
                    label="CGT percentage"
                    onChange={(v) => onChange({ CgtPercentage: v })}
                    value={data?.CgtPercentage}
                    cssWrapper="control-size-245"
                    validationRules={[
                        {
                            validator: (v) => {
                                if (
                                    accountInfo?.InvestorType == InvestorType.Joint ||
                                    accountInfo?.InvestorType == InvestorType.JointIndividual
                                ) {
                                    return v <= 200;
                                }
                                return v <= 100;
                            },
                            errorMessage:
                                accountInfo?.InvestorType == InvestorType.Joint ||
                                accountInfo?.InvestorType == InvestorType.JointIndividual
                                    ? "Only number from 0-200 can be saved for Joint account."
                                    : "Only numbers from 0-100 can be saved for Individual and Trust account",
                        },
                        {
                            validator: (v) => {
                                return v >= 0;
                            },
                            errorMessage:
                                accountInfo?.InvestorType == InvestorType.Joint ||
                                accountInfo?.InvestorType == InvestorType.JointIndividual
                                    ? "Only number from 0-200 can be saved for Joint account."
                                    : "Only numbers from 0-100 can be saved for Individual and Trust account",
                        },
                    ]}
                />
            </PartLoading>
        );
    }
}
